import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { environment } from '../../../../environments/environment';
export type LegalSection = 'condiciones' | 'privacidad' | 'uso-individual' | 'cookies';

export interface LegalDialogData {
  section: LegalSection;
}

@Component({
  standalone: true,
  selector: 'app-legal-dialog',
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './legal-dialog.component.html',
  styleUrls: ['./legal-dialog.component.scss'],
})
export class LegalDialogComponent {
  readonly marca = environment.marca;
  section: LegalSection;

  titles: Record<LegalSection, string> = {
    condiciones: 'Condiciones de uso',
    privacidad: 'Protección de datos',
    'uso-individual': 'Uso individual de la plataforma',
    cookies: 'Política de Cookies',
  };

  constructor(
    public dialogRef: MatDialogRef<LegalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LegalDialogData
  ) {
    this.section = data.section;
  }

  get title(): string {
    return this.titles[this.section];
  }

  close() {
    this.dialogRef.close();
  }
}
